import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { InstrumentType } from '@zero/shared/util-models';
import { environment } from 'environments/environment';
import { CallMoneyAlternatives } from '../entities/call-money-alternatives.entity';
import { EtfsByIndices } from '../entities/etfs-by-indices.entity';
import { MostActiveAssets } from '../entities/most-active-assets.entity';
import { MostPopular } from '../entities/most-popular.entity';
import { WinnerLoser } from '../entities/winner-loser.entity';

@Injectable({ providedIn: 'root' })
export class AssetClassOverviewInfrastructure {
  readonly #http = inject(HttpClient);
  readonly #baseApi = `${environment.apihost}/api/overview-page`;

  public loadEtfsByIndices = () => this.#http.get<EtfsByIndices[]>(`${this.#baseApi}/indices-with-etfs`);
  public loadMostPopularEtfs = () => this.#http.get<MostPopular>(`${this.#baseApi}/etf/most-popular`);
  public loadMostPopularStocks = () => this.#http.get<MostPopular>(`${this.#baseApi}/stock/most-popular`);
  public loadCallMoneyAlternatives = () => this.#http.get<CallMoneyAlternatives[]>(`${this.#baseApi}/fixed-deposit-alternatives`);
  public loadMostActiveAssets = (instrumentType: InstrumentType) =>
    this.#http.get<MostActiveAssets>(`${this.#baseApi}/most-traded-instruments/${instrumentType}`);
  public loadWinnerLoser = (instrumentType: InstrumentType) =>
    this.#http.get<WinnerLoser>(`${this.#baseApi}/${instrumentType === InstrumentType.Share ? 'stock' : 'etf'}/tops-flops`);
}
